import { type EpgDateEx } from '$/epg/dates'
import { type TFunction } from 'i18next'
import { produce } from 'immer'
import { DATE_FORMATS, formatStartTime } from '~/shared/helpers/date'

export const translateDate = (t: TFunction) => (date: EpgDateEx) =>
  produce(date, (draft) => {
    const yesterday = t('yesterday')
    const today = t('today')
    const title = formatStartTime(
      new Date(draft.year, draft.month, draft.day),
      DATE_FORMATS.DD_MMM
    )
    if (draft.isYesterday) {
      draft.title = `${yesterday}, ${title}`
    } else if (draft.isToday) {
      //TODO: combine each of this string in translations strings in i18n yaml files
      draft.title = `${today}, ${title}`
    } else {
      draft.title = title
    }
  })
